import React from 'react';

import { TIPTAP_DIVIDER_TYPE } from './../ricos-content';
import { DividerData_Alignment, DividerData_Width } from './../ricos-schema/legacy/wix/rich_content/v1';
import type { RicosServices, ToolbarButton } from './../ricos-types';
import { PLUGIN_TOOLBAR_ALIGNMENT_BUTTON } from './../_shared/data-hooks';
import { PLUGIN_TOOLBAR_BUTTON_ID } from './../editor-common';
import {
  getVisibleOnlyOnDesktopResolver,
  selectedNodeResolver,
} from './../plugin-commons';

import { DIVIDER_BUTTONS, DIVIDER_SIZE_RESOLVER_ID, DIVIDER_STYLE_RESOLVER_ID } from './const';
import {
  PLUGIN_TOOLBAR_DIVIDER_SIZE_BUTTON,
  PLUGIN_TOOLBAR_DIVIDER_STYLE_BUTTON,
} from './data-hooks';
import { DividerAlignmentButton } from './toolbar/buttons/DividerAlignmentButton';
import { DividerSizeButton } from './toolbar/buttons/DividerSizeButton';
import { DividerStyleButton } from './toolbar/buttons/DividerStyleButton';

const resolveDividerAttribute = ({
  resolverId,
  attribute,
}: {
  resolverId: string;
  attribute: string;
}) => {
  return {
    id: resolverId,
    resolve: (content: $TSFixMe) => {
      if (Array.isArray(content) && content.length > 0) {
        return content.find(node => node.type.name === TIPTAP_DIVIDER_TYPE)?.attrs?.[attribute];
      } else {
        return undefined;
      }
    },
  };
};

export const getToolbarButtons = (_config: $TSFixMe, services: RicosServices): ToolbarButton[] => {
  const {
    context: { isMobile },
  } = services;

  return [
    {
      id: DIVIDER_BUTTONS.style,
      dataHook: PLUGIN_TOOLBAR_DIVIDER_STYLE_BUTTON,
      command: ({ value, tiptapEditor }) => {
        tiptapEditor
          .chain()
          .focus()
          .updateAttributes(TIPTAP_DIVIDER_TYPE, {
            lineStyle: value,
          })
          .run();
      },
      attributes: {
        nodeStyle: resolveDividerAttribute({
          resolverId: DIVIDER_STYLE_RESOLVER_ID,
          attribute: 'lineStyle',
        }),
      },
      renderer: toolbarItem => (
        <DividerStyleButton toolbarItem={toolbarItem} id={DIVIDER_BUTTONS.style} />
      ),
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
    },
    {
      id: DIVIDER_BUTTONS.size,
      dataHook: PLUGIN_TOOLBAR_DIVIDER_SIZE_BUTTON,
      command: ({ value, tiptapEditor, attributes: { selectedNode } }) => {
        const nodeContainerData = selectedNode.attrs?.containerData;
        const isFullWidth = value === DividerData_Width.LARGE;
        const newAttributes = isFullWidth
          ? {
              width: value,
              alignment: DividerData_Alignment.CENTER,
              containerData: { ...nodeContainerData, alignment: DividerData_Alignment.CENTER },
            }
          : { width: value };
        tiptapEditor.chain().focus().updateAttributes(TIPTAP_DIVIDER_TYPE, newAttributes).run();
      },
      attributes: {
        nodeSize: resolveDividerAttribute({
          resolverId: DIVIDER_SIZE_RESOLVER_ID,
          attribute: 'width',
        }),
        selectedNode: selectedNodeResolver,
        visible: getVisibleOnlyOnDesktopResolver(isMobile),
      },
      renderer: toolbarItem => (
        <DividerSizeButton toolbarItem={toolbarItem} id={DIVIDER_BUTTONS.size} />
      ),
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile),
      },
    },
    {
      id: DIVIDER_BUTTONS.alignment,
      dataHook: PLUGIN_TOOLBAR_ALIGNMENT_BUTTON,
      command: ({ value, tiptapEditor, attributes: { selectedNode } }) => {
        const nodeContainerData = selectedNode.attrs?.containerData;
        tiptapEditor
          .chain()
          .focus()
          .updateAttributes(TIPTAP_DIVIDER_TYPE, {
            alignment: value,
            containerData: { ...nodeContainerData, alignment: value },
          })
          .run();
      },
      attributes: {
        selectedNode: selectedNodeResolver,
        visible: getVisibleOnlyOnDesktopResolver(isMobile),
      },
      renderer: toolbarItem => (
        <DividerAlignmentButton id={DIVIDER_BUTTONS.alignment} toolbarItem={toolbarItem} />
      ),
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile),
      },
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
    },
  ];
};
